// Brand and model as two labelled values, so it is never a guess which word is
// which. Shared by the identity card (worker and KG answers) and the identify
// popup, so every identification on the page reads the same way.
export default function BrandModel({ brand, model, category }) {
    return (
        <dl className="qa-idc-pair">
            <dt>Brand</dt>
            <dd>{brand || <span className="qa-muted">none</span>}</dd>
            <dt>Model</dt>
            <dd>
                {model || <span className="qa-muted">none</span>}
                {category ? <span className="qa-muted"> · {category}</span> : null}
            </dd>
        </dl>
    );
}
